export default "__VITE_ASSET__DG4D1Ni1__"